export default "__VITE_ASSET__C09uiY6S__"